import React from 'react';
import { setClassNames } from '@ddc/classnames-js';
import PropTypes from 'prop-types';

const GalleryButton = (props) => {
	const {
		activeToolBar,
		btnLabel,
		btnSpace,
		handleClick,
		isGalleryModal = false,
		isOverlayButton = false,
		isTextLinkMode,
		thumbnailUrl,
		value,
		icon
	} = props;

	const btnOverlayClass = [
		'gallery-button',
		'w-60',
		`${btnSpace}`,
		'gallery-button-overlay',
		'border-radius-sm',
		'py-2',
		'px-3',
		'd-inline-flex align-items-center',
		'text-white',
		'border-0',
		'line-height-condensed'
	];
	const btnNormalClass = [
		'gallery-button',
		'border-left-0',
		'border-top-0',
		'border-right-0',
		'w-60',
		`${btnSpace}`,
		'bg-transparent',
		'text-body',
		isGalleryModal && activeToolBar === value
			? 'gallery-button--active p-0'
			: 'gallery-button--inactive p-0',
		isGalleryModal && activeToolBar !== value && 'text-muted',
		isTextLinkMode ? 'd-flex align-items-center' : ''
	];

	const buttonContent = (
		<>
			{isTextLinkMode ? (
				<i
					data-testid="text-icon"
					aria-hidden="true"
					className={setClassNames(['ddc-icon', `${icon}`, 'mr-3'])}
				/>
			) : (
				<div
					data-testid="thumbnail-icon"
					className={setClassNames([
						'position-relative',
						'gallery-button-thumb-container',
						'mb-3'
					])}
					style={{
						backgroundImage: `url("${thumbnailUrl}")`
					}}
				>
					<div
						className={setClassNames([
							'gallery-button-thumb-bg-icon',
							'position-absolute',
							'rounded-circle'
						])}
					>
						<i
							aria-hidden="true"
							className={setClassNames([
								'ddc-icon',
								`${icon}`,
								'ddc-icon-size-xlarge',
								'text-white'
							])}
						/>
					</div>
				</div>
			)}
			<span
				className={setClassNames([
					'ddc-font-size-xsmall',
					'font-weight-bold'
				])}
			>
				{btnLabel}
			</span>
		</>
	);
	return (
		<button
			type="button"
			onClick={handleClick}
			data-testid="gallery-button"
			className={setClassNames([
				...(isOverlayButton ? btnOverlayClass : btnNormalClass)
			])}
		>
			{buttonContent}
		</button>
	);
};

GalleryButton.propTypes = {
	activeToolBar: PropTypes.number,
	btnLabel: PropTypes.string,
	btnSpace: PropTypes.string,
	handleClick: PropTypes.func,
	icon: PropTypes.string,
	isGalleryModal: PropTypes.bool,
	isOverlayButton: PropTypes.bool,
	isTextLinkMode: PropTypes.bool.isRequired,
	thumbnailUrl: PropTypes.string,
	value: PropTypes.number
};

export default GalleryButton;
